import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";
import HomePage from "../views/components/homePage.vue";
import AboutUs from "../views/components/aboutUs.vue";
import ContactUs from "../views/components/contactUs.vue";
import BimFullProcessService from "../views/components/bimFullProcessService.vue";
import SmartDigitalService from "../views/components/smartDigitalService.vue";
import IotPerceptionService from "../views/components/iotPerceptionService.vue";
import DigitalTerrainService from "../views/components/digitalTerrainService.vue";
import PlatformCustomization from "../views/components/platformCustomization.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
    redirect: "/HomePage",
    children: [
      {
        path: "/HomePage",
        name: "HomePage",
        component: HomePage,
      },
      {
        path: "/BimFullProcessService",
        name: "BimFullProcessService",
        component: BimFullProcessService,
      },
      {
        path: "/SmartDigitalService",
        name: "SmartDigitalService",
        component: SmartDigitalService,
      },
      {
        path: "/IotPerceptionService",
        name: "IotPerceptionService",
        component: IotPerceptionService,
      },
      {
        path: "/DigitalTerrainService",
        name: "DigitalTerrainService",
        component: DigitalTerrainService,
      },
      {
        path: "/PlatformCustomization",
        name: "PlatformCustomization",
        component: PlatformCustomization,
      },
      {
        path: "/AboutUs",
        name: "AboutUs",
        component: AboutUs,
      },
      {
        path: "/ContactUs",
        name: "ContactUs",
        component: ContactUs,
      },
    ],
  },

  // {
  //   path: '/about',
  //   name: 'about',
  //   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  // }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
